export default __webpack_public_path__ + "static/media/avatar_103.df6dd147.png";